exports.currentUrl = process.env.VUE_APP_API_URL
exports.lmsUrl = process.env.VUE_APP_LMS_URL
exports.aadhaar_verification = process.env.VUE_APP_AADHAAR_VERIFY_URL
exports.aadhaar_ocr = process.env.VUE_APP_AADHAAR_OCR_URL
exports.reportUrl = process.env.VUE_APP_V3_REPORTS_URL
exports.backendUrl = process.env.VUE_APP_V3_BACKEND_URL
